/**
 * Compliance-issue keys emitted by the §14 LQG-consolidation rules. §14 is now
 * submission-scoped: its rules live in `submissionRcraConsolidationSchema` and
 * their issues carry `modelName === "SubmissionRcraConsolidation"`. (The
 * `isLqgConsolidator` gate still persists on `FacilityRcraProfile`, but the
 * consolidation validation — gate + sites — runs through the submission
 * schema.) These fields are edited on the Filing Notifications step, so §14
 * issues are surfaced there and excluded from the Facility Profile step.
 *
 * Keep in sync with the §14 rules in
 * packages/encamp-compliance-engine/src/schemas/rcra/submissionRcraConsolidationSchema.ts —
 * every §14 rule must hang off one of these field keys.
 */
export const CONSOLIDATION_ISSUE_KEYS = new Set(["isLqgConsolidator", "consolidatedSites"]);
